import { render, staticRenderFns } from "./Cadastro-Usuarios-Adicionar-Admin.vue?vue&type=template&id=07771b94&"
import script from "./Cadastro-Usuarios-Adicionar-Admin.vue?vue&type=script&lang=js&"
export * from "./Cadastro-Usuarios-Adicionar-Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Cadastro-Usuarios-Adicionar-Admin.vue"
export default component.exports